import { MintToTokenFormData, OperationType, Token, TraderAddress } from '@archax/shared-types'
import { yupResolver } from '@hookform/resolvers/yup'
import { ButtonGroup } from '@mui/material'
import Button from '@mui/material/Button'
import { useMutation } from '@tanstack/react-query'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import { createOperation } from '../../../../api/operations'
import TextField from '../../../../components/ui/TextField/TextField'
import onApiError from '../../../../util/on-api-error'
import { tokenAmountValidator } from '../../../../util/yup-validators'
import { HederaAssociateHelper } from '../HederaAssociateHelper'

interface MintToTokenProps {
  token: Token
  isNft: boolean
  onSuccess: () => void
  account?: TraderAddress
  poolToken?: Token
}

function MintToTokenForm({ token, onSuccess, account, poolToken, isNft }: MintToTokenProps) {
  const { id, decimals } = token
  const validationSchema = Yup.object()
    .shape({
      amount: tokenAmountValidator({ decimals, positive: true }),
    })
    .required()
  const initialValues = { amount: isNft ? '1' : '0' }
  const { mutate } = useMutation(
    (formData: MintToTokenFormData) => createOperation(OperationType.Mint, formData, id, account && account.trader.id),
    {
      onSuccess: (data) => {
        toast.success('Mint token request sent for approval')
        onSuccess()
      },
      onError: onApiError,
    },
  )

  const onSubmit = (data: MintToTokenFormData) => {
    const operationData = account ? { traderAddressId: account.id, ...data } : { poolTokenId: poolToken!.id, ...data }
    mutate(operationData)
  }

  const {
    control,
    handleSubmit,
    formState: { isDirty, isValid, isSubmitting, isSubmitSuccessful },
  } = useForm<MintToTokenFormData>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  })

  const isSubmitButtonDisabled = !isNft && (!isDirty || !isValid || isSubmitting || isSubmitSuccessful)

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {!isNft && <TextField name="amount" type="number" control={control} label="Number to mint" />}
      <ButtonGroup fullWidth>
        <Button
          disabled={isSubmitButtonDisabled}
          type="submit"
          variant="contained"
          size="large"
          color="primary"
          fullWidth
        >
          Mint
        </Button>
      </ButtonGroup>
      <HederaAssociateHelper token={token} />
    </form>
  )
}
export default MintToTokenForm
